import { render, staticRenderFns } from "./desc_list.vue?vue&type=template&id=b18dea6a&scoped=true"
import script from "./desc_list.vue?vue&type=script&lang=ts"
export * from "./desc_list.vue?vue&type=script&lang=ts"
import style0 from "./desc_list.vue?vue&type=style&index=0&id=b18dea6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18dea6a",
  null
  
)

export default component.exports